module.exports = __webpack_public_path__ + "static/media/riberman.01ac78d1.png";